var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeTabName),callback:function ($$v) {_vm.activeTabName=$$v},expression:"activeTabName"}},[_c('el-tab-pane',{attrs:{"name":"账号留存","label":"账号留存"}},[(_vm.activeTabName == '账号留存')?_c('AccountRetentionPage'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }